import styled, { css } from 'styled-components'
import { breakpoints } from '@src/constants/breakpoints'
import { CaretRight } from '../SVGS/CaretRight'

export const LinkSlideContainer = styled.div`
  margin: 0 0 0 12px;
  border-radius: 8px;
  width: 260px;
  height: 290px;

  display: flex;
  flex-direction: column;
  background-color: rgba(200, 200, 200, 0.3);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  box-shadow: rgba(0, 0, 0, 0) 0px 1px 4px; /* Start with transparent shadow */
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  }

  @media (min-width: ${breakpoints.tablet}px) {
    width: 298px;
    height: 300px;
    margin: 0 0 0 28px;
  }

  overflow: hidden;
`

export const LinkSlideContent = styled.div<{ image?: string }>`
  height: 290px;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  &:hover {
    .image {
      transform: scale(1.05); /* Adjust the scale as needed */
    }
  }
  ${props =>
    props.image &&
    css`
      .image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url(${props.image});
        background-size: cover;
        background-position: center;
        transition: transform 0.3s ease-in-out;
        z-index: 1;

        overflow: hidden;
      }
    `};
  .content {
    z-index: 2;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  @media (min-width: ${breakpoints.tablet}px) {
    width: 298px;
    height: 300px;
  }
`

export const LinkSlideTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin-top: 12px;
`

export const LinkSlideSpacer = styled.div`
  flex-grow: 2;
`

export const LinkSlideDetailsContainer = styled.div`
  padding: 0px 16px 16px 16px;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${({ theme }) => `${theme.colors.linkCard}F2`};
  color: #fff;

  height: 108px;
`

export const LinkSlideDescription = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  overflow: hidden;
  color: #fff;

  @media (max-width: ${breakpoints.tablet}px) {
    padding: 0 0px;
  }
`

export const MoreLinkContainer = styled.div`
  display: flex;
  align-items: center;
`

export const MoreLinkContent = styled.div`
  font-weight: 700;
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;

  @media (max-width: ${breakpoints.tablet}px) {
    font-size: 12px;
  }
`

export const MoreLinkSvg = styled(CaretRight)`
  color: #fff;
`
